/* Compact Chat Assistant palette (Page redesign: compact layout handoff).
   Purple only: status is shown with purple and neutral tones, never
   green/yellow/orange. */

export const C = {
  page: 'var(--om-page)',
  surface: 'var(--om-surface)',
  card: 'var(--om-card)',
  input: 'var(--om-panel)',
  hover: 'var(--om-hover)',
  border: 'var(--om-border)',
  borderHi: 'var(--om-border-hi)',
  borderLo: 'var(--om-border-lo)',
  divider: 'var(--om-divider)',
  text: 'var(--om-text)',
  sub: 'var(--om-sub)',
  muted: 'var(--om-muted)',
  faint: 'var(--om-faint)',
  body: 'var(--om-body)',
  purple: 'var(--om-accent)',
  purpleLt: 'var(--om-accent-2)',
  purplePale: 'var(--om-accent-3)',
  tint16: 'color-mix(in srgb, var(--om-accent) 16%, transparent)',
  tint20: 'color-mix(in srgb, var(--om-accent) 20%, transparent)',
  tintLine: 'color-mix(in srgb, var(--om-accent) 35%, transparent)',
  tintLine45: 'color-mix(in srgb, var(--om-accent) 45%, transparent)',
  segActive: 'var(--om-seg)',
  toggleOff: 'var(--om-border-hi)',
  track: 'var(--om-track)',
  stripe: 'repeating-linear-gradient(135deg,var(--om-card-2) 0 6px,var(--om-card) 6px 12px)',
} as const;

export const FONT = 'var(--font-sans)';
